/**
 * Supabase connection for maintenance-page telemetry.
 *
 * Paste the values from Supabase → Project Settings → API. The anon key is safe
 * in client code ONLY because the schema in supabase/schema.sql grants the anon
 * role insert-on-one-table and execute-on-one-aggregate-function — never select
 * on raw rows. Do not paste the service_role key here.
 *
 * Leave `url` or `anonKey` empty to keep the dashboard on bundled sample data.
 */
export const supabaseConfig = {
  /** e.g. 'https://abcdefgh.supabase.co' */
  url: 'https://acbylynxriiruxaurzfd.supabase.co',
  /** The public "anon" / publishable key. */
  anonKey: 'sb_publishable_47hOCHAQbubJ0qYagSw_9A_SwibRVgU',
  /** Table that receives one row per maintenance-page event. */
  eventsTable: 'maintenance_events',
  /** Postgres function that returns the aggregated dashboard payload. */
  aggregateFunction: 'maintenance_traffic',
  /** Host being reported on, stored with every event. */
  monitoredHost: 'work.turing.com',
  /** Size of the dashboard's lookback window, in minutes. */
  lookbackMinutes: 360
}

export function isSupabaseConfigured(): boolean {
  return supabaseConfig.url.trim().length > 0 && supabaseConfig.anonKey.trim().length > 0
}
